export const getCookie = (name: string) => {
  const cookieName = `${document.cookie};`.match(new RegExp(`${name}=.*;`));
  return cookieName && cookieName[0].split(/=|;/)[1];
};

export const setCookie = (name: string, value: string, days?: number) => {
  const e = new Date();
  e.setDate(e.getDate() + (days || 365));

  const domain = `.${process.env.ENV_HOST || 'localhost'}`;

  document.cookie = `${name}=${value};expires=${e.toUTCString()};domain=${domain};path=/`;
};

export const deleteCookie = (name: string) => {
  setCookie(name, null, -1);
  const date = new Date();

  date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);

  document.cookie = `${name}=; expires=${date.toUTCString()}; path=/`;
};
